import * as Sentry from '@sentry/react';
import { captureSentryEvent } from '../../../../utils/errorHandling';
import { ProductFamily, ProductWorkflow, } from '../../../../types/_ProductSpecificTypes';
var isScriptRequested = false;
export var VgsEvents;
(function (VgsEvents) {
    VgsEvents["AddVgsCardForm"] = "AddVgsCardForm";
    VgsEvents["InjectVgs"] = "InjectVgs";
})(VgsEvents || (VgsEvents = {}));
function isVgsScriptLoaded() {
    return Boolean(window.VGSCollect);
}
export function vgsScriptOnload() {
    return new Promise(function (resolve, reject) {
        if (isVgsScriptLoaded()) {
            return resolve(true);
        }
        var iterations = 0;
        var interval = setInterval(function () {
            iterations = iterations + 1;
            if (iterations >= 100) {
                clearInterval(interval);
                return reject(new Error('Failed to load VGS vendor script'));
            }
            else if (isVgsScriptLoaded()) {
                clearInterval(interval);
                return resolve(true);
            }
        }, 50);
    });
}
// VGS Collect.js is a JavaScript library that allows you to securely collect
// data via any form. Instantly create custom forms that adhere to PCI, HIPAA,
// GDPR or CCPA security requirements. VGS intercepts sensitive data before it
// hits your servers and replaces it with aliased versions while securing the
// original data in our vault. The form fields behave like traditional forms
// while preventing access to the unsecured data by injecting secure iframe
// components.
//
// TLDR: VGS is a new tokenizer provider used for payments instead of Stripe.
export function injectVgs(vgsConfig) {
    if (typeof window === 'undefined') {
        throw new Error('Window is not defined');
    }
    if (isScriptRequested) {
        return vgsScriptOnload();
    }
    isScriptRequested = true;
    // Load vendor script once with injected script tag.
    var script = document.createElement('script');
    script.src = vgsConfig.SCRIPT_URL;
    document.head.append(script);
    script.onerror = function (e) {
        captureVgsEvent(VgsEvents.InjectVgs, { vgsConfig: vgsConfig, scriptError: e }, new Error('Global VGS script failed to load'));
    };
    return vgsScriptOnload();
}
export var captureVgsEvent = function (component, context, error) {
    captureSentryEvent(Sentry.Severity.Warning, (error === null || error === void 0 ? void 0 : error.message) || 'Vgs Error', {
        productFamily: ProductFamily.ExpensedMeals,
        // All VGS error is assumed to be because of add card
        productWorkflow: ProductWorkflow.AddPaymentCard,
    }, { context: context, error: error }, { component: component });
};
